<div class="logging-tests-container">
  <div class="card">
    <div class="card-header">
      <h3>Logging Tests</h3>
      <p class="text-muted">Test Application Insights logging by calling TestController endpoints on both WebAPI and Reporting services.</p>
    </div>

    <div class="card-body">
      <!-- Control Panel -->
      <div class="control-panel mb-4">
        <!-- Test Buttons -->
        <div class="row">
          <div class="col-md-6 mb-3">
            <div class="card">
              <div class="card-header">
                <h5 class="mb-0">WebAPI</h5>
              </div>
              <div class="card-body">
                <div class="d-grid gap-2">
                  <button
                    type="button"
                    class="btn btn-primary"
                    (click)="testWebApiLogging()"
                    [disabled]="webApiLoggingLoading" data-testid="logging-tests-test-logging">
                    <span *ngIf="webApiLoggingLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    <i class="fas fa-bug me-2" *ngIf="!webApiLoggingLoading"></i>
                    Test Logging
                  </button>

                  <!-- WebAPI Logging Result -->
                  <div class="test-result mt-2" *ngIf="webApiLoggingResult">
                    <div class="alert" [ngClass]="webApiLoggingResult.success ? 'alert-success' : 'alert-danger'">
                      <div class="d-flex justify-content-between align-items-start">
                        <div class="flex-grow-1">
                          <div class="d-flex align-items-center mb-1">
                            <i [class]="webApiLoggingResult.success ? 'fas fa-check-circle me-2' : 'fas fa-times-circle me-2'"></i>
                            <strong>{{ webApiLoggingResult.success ? 'Success' : 'Failed' }}</strong>
                          </div>
                          <small>{{ webApiLoggingResult.message }}</small>
                          <br>
                          <small class="text-muted">{{ webApiLoggingResult.timestamp | date:'medium' }}</small>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 mb-3">
            <div class="card">
              <div class="card-header">
                <h5 class="mb-0">Reporting Service</h5>
              </div>
              <div class="card-body">
                <div class="d-grid gap-2">
                  <button
                    type="button"
                    class="btn btn-primary"
                    (click)="testReportingLogging()"
                    [disabled]="reportingLoggingLoading" data-testid="logging-tests-reporting-service-test-logging">
                    <span *ngIf="reportingLoggingLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    <i class="fas fa-bug me-2" *ngIf="!reportingLoggingLoading"></i>
                    Test Logging
                  </button>

                  <!-- Reporting Logging Result -->
                  <div class="test-result mt-2" *ngIf="reportingLoggingResult">
                    <div class="alert" [ngClass]="reportingLoggingResult.success ? 'alert-success' : 'alert-danger'">
                      <div class="d-flex justify-content-between align-items-start">
                        <div class="flex-grow-1">
                          <div class="d-flex align-items-center mb-1">
                            <i [class]="reportingLoggingResult.success ? 'fas fa-check-circle me-2' : 'fas fa-times-circle me-2'"></i>
                            <strong>{{ reportingLoggingResult.success ? 'Success' : 'Failed' }}</strong>
                          </div>
                          <small>{{ reportingLoggingResult.message }}</small>
                          <br>
                          <small class="text-muted">{{ reportingLoggingResult.timestamp | date:'medium' }}</small>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div class="empty-state text-center py-5" *ngIf="!webApiLoggingResult && !reportingLoggingResult">
        <i class="fas fa-search text-muted" style="font-size: 3rem;"></i>
        <h4 class="text-muted mt-3">No Test Results</h4>
        <p class="text-muted">Click any of the test buttons above to execute logging tests and view results.</p>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/developer/components/developer-tools/logging-tests/logging-tests.component.html